import _ from 'lodash';

/**
 * Checks whether a given step name is included in any of the steps associated to the error
 * @param {string} currentStepName the step name that should match the step declared in the error
 * @param {Object} error the error which associated steps should be checked to match againts the given currentStepName
 * @returns {boolean} returns true if any of the steps associated to the given error match the currentStepName
 */
function errorMatchesStep(currentStepName, error) {
    return _.includes(error.wizardSteps, currentStepName);
}

/**
 * Check that the steps where a specific error can occour are not defined
 * E.g. an error occours but it's not clear which wizard step generated that
 *
 * @param {Object} error wizard error
 * @returns {boolean} true if no error is associated to the current step
 */
function errorHasNoStep(error) {
    return _.isEmpty(error.wizardSteps);
}

export default ['$scope', '$state', 'FlowValidationService', function ($scope, $state, FlowValidationService) {

    this.$onInit = () => {
        const currentStepName = $state.current.name;
        const types = _.get(this, 'types', '').split(',').map(text => text.trim());
        // notice that the getDisplayableErrors only returns errors for visited steps
        const getErrorsForStep = () => FlowValidationService.getDisplayableErrors({types, includeErrorsOnCurrentStep: true})
            .filter(error => errorMatchesStep(currentStepName, error) || errorHasNoStep(error));

        $scope.$watch(getErrorsForStep, (newErrors) => {
            $scope.errors = newErrors;
        }, true);

        $scope.dismiss = (warningId) => {
            FlowValidationService.acknowledgeWarning(warningId);
        };

        $scope.errors = getErrorsForStep();
    };

}];
